import { render, staticRenderFns } from "./SendVerificationForm.vue?vue&type=template&id=99577c68&scoped=true"
import script from "./SendVerificationForm.vue?vue&type=script&lang=ts"
export * from "./SendVerificationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99577c68",
  null
  
)

export default component.exports